const E="SET_REGISTER_MODAL";export{E as S};
